import React from "react"

import Navigation from "../components/Navigation/navigation"
import Header from "../components/Header/header"
import Features from "../components/Features/features"
import Schedule from "../components/Schedule/schedule"
import Insurances from "../components/Insurances/insurances"
import Location from "../components/Location/location"
import Footer from "../components/Footer/footer"
import SEO from "../components/SEO/SEO"

import "../styles/base.css"
import classes from "../styles/index.module.scss"
export default function Home() {
  return (
    <React.Fragment>
      <SEO />
      <Navigation />
      <div className={classes.Container}>
        <Header />
        <Features />
        <Schedule />
        <Insurances />
        <Location />
        <Footer />
      </div>
    </React.Fragment>
  )
}
